import { useEffect } from "react";
import Lenis from "lenis";
import "@/App.css";
import { Nav } from "@/components/landing/Nav";
import { Hero } from "@/components/landing/Hero";
import { Credentials } from "@/components/landing/Credentials";
import { Marquee } from "@/components/landing/Marquee";
import { Company } from "@/components/landing/Company";
import { Manufacturing } from "@/components/landing/Manufacturing";
import { JICSection } from "@/components/landing/JICSection";
import { Verification } from "@/components/landing/Verification";
import { ContactFooter } from "@/components/landing/ContactFooter";
import { WhatsAppButton } from "@/components/landing/WhatsAppButton";

function App() {
  useEffect(() => {
    const lenis = new Lenis({ lerp: 0.09, smoothWheel: true, anchors: true });
    const raf = (time) => {
      lenis.raf(time);
      requestAnimationFrame(raf);
    };
    requestAnimationFrame(raf);
    return () => lenis.destroy();
  }, []);

  return (
    <div className="page">
      <Nav />
      <main>
        <Hero />
        <Credentials />
        <Marquee />
        <Company />
        <Manufacturing />
        <JICSection />
        <Verification />
        <ContactFooter />
      </main>
      <WhatsAppButton />
    </div>
  );
}

export default App;
